<p-dialog header="Report a Bug" [modal]="true" [(visible)]="isReportBugModalVisible" [style]="{ width: '50rem' }">
  <div class="flex align-items-center gap-3 mb-5">
    <p><strong>Please include the following URL when reporting your bug:</strong></p>
    <div class="input-group">
      <input type="text" class="form-control" aria-describedby="sessionUrlHelp" pInputText
        [(ngModel)]="this.sessionUrl" />
      <button class="btn btn-sm btn-primary" type="button" id="button-addon2" (click)="copyToClipboard()">Copy
        to
        Clipboard</button>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-2">
    <button class="btn btn-sm btn-outline-primary" (click)="isReportBugModalVisible = false">Close</button>
  </div>
</p-dialog>

<header class="navbar sticky-top p-0 shadow">
  <a class="navbar-brand me-0 px-3 fs-6 text-white" routerLink="/" routerLinkActive="active">
    <img src="../../../assets/images/lexicon-white-logo-300x48.png" alt="Lexicon Logo"
      class="d-inline-block align-text-top">
    {{appTitle}}
  </a>
  <div class="btn-group header-menu" role="group" aria-label="Button group with nested dropdown">
    <button *ngIf="canReport" class="btn btn-sm btn-link" href="" (click)="reportBug()">Report a Bug</button>
    <button class="btn btn-sm btn-link" (click)="logout()">Log Out</button>
  </div>
</header>